/* Eva & Theo · global.js */
(function () {
  'use strict';

  /* ---------- Lazy images (data-lazy) ----------
     Native loading=lazy still fetches everything within ~2500px on slow connections,
     which made review/card photos compete with the LCP image. These images start only
     when they near the viewport AND the page's LCP image (fetchpriority=high) has finished. */
  var lazyObserver = null;
  function loadLazyImage(img) {
    var sizes = img.getAttribute('data-sizes');
    var srcset = img.getAttribute('data-srcset');
    var src = img.getAttribute('data-src');
    if (sizes) img.sizes = sizes;
    if (srcset) img.srcset = srcset;
    if (src) img.src = src;
    img.removeAttribute('data-lazy');
  }
  function observeLazyImages() {
    var imgs = document.querySelectorAll('img[data-lazy]:not([data-lazy-observed])');
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) { imgs.forEach(loadLazyImage); return; }
    if (!lazyObserver) {
      lazyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { loadLazyImage(e.target); lazyObserver.unobserve(e.target); }
        });
      }, { rootMargin: '300px 0px' });
    }
    imgs.forEach(function (img) { img.setAttribute('data-lazy-observed', ''); lazyObserver.observe(img); });
  }
  var lazyStarted = false;
  function initLazyImages() {
    if (lazyStarted) { observeLazyImages(); return; }
    var hero = document.querySelector('img[fetchpriority="high"]');
    var start = function () { if (lazyStarted) return; lazyStarted = true; observeLazyImages(); };
    if (hero && !hero.complete) {
      hero.addEventListener('load', start);
      hero.addEventListener('error', start);
      setTimeout(start, 4000); /* safety net: never wait longer than 4 s */
    } else {
      start();
    }
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('is-revealed');
      } else {
        io.observe(el);
      }
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;
    var close = menu.querySelector('[data-menu-close]');
    toggle.addEventListener('click', function () {
      menu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    function closeMenu() {
      menu.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (close) close.addEventListener('click', closeMenu);
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
  }

  /* ---------- Header search toggle ---------- */
  function initSearchToggle() {
    var toggle = document.querySelector('[data-search-toggle]');
    var panel = document.querySelector('[data-search-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      panel.classList.toggle('is-open');
      if (panel.classList.contains('is-open')) {
        var input = panel.querySelector('input[type="search"], input[name="q"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Cart count ---------- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', String(count));
      el.classList.remove('is-popping');
      void el.offsetWidth; /* restart animation */
      el.classList.add('is-popping');
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    var select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    var root = document.querySelector('[data-product]');
    if (!root) return;

    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var variants = product.variants || [];
    var moneyFormat = root.getAttribute('data-money-format') || '€{{amount_with_comma_separator}}';

    var mainImage = root.querySelector('[data-main-image]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var priceEls = root.querySelectorAll('[data-price]');
    var compareEls = root.querySelectorAll('[data-compare-price]');
    var saveEl = root.querySelector('[data-save-badge]');
    var idInput = root.querySelector('[data-variant-id]');
    var buyButtons = root.querySelectorAll('[data-add-to-cart]');
    var stockNote = root.querySelector('[data-stock-note]');
    var optionGroups = root.querySelectorAll('[data-option-group]');

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var withComma = amount.replace('.', ',');
      var noDecimals = String(Math.round(cents / 100));
      return moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
        .replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    /* Gallery */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        var img = mainImage ? mainImage.querySelector('img') : null;
        if (img && src) {
          var mobileSource = mainImage.querySelector('[data-main-source]');
          var srcsetMobile = thumb.getAttribute('data-srcset-mobile');
          if (mobileSource && srcsetMobile) mobileSource.srcset = srcsetMobile;
          img.src = src;
          if (srcset) img.srcset = srcset;
          var alt = thumb.getAttribute('data-alt');
          if (alt !== null) img.alt = alt;
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* Variant selection */
    function selectedOptions() {
      var opts = [];
      optionGroups.forEach(function (group) {
        var sel = group.querySelector('.option-pill.is-selected');
        opts.push(sel ? sel.getAttribute('data-value') : null);
      });
      return opts;
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updateUI(variant) {
      if (!variant) {
        buyButtons.forEach(function (b) {
          b.disabled = true;
          var label = b.querySelector('[data-cta-label]') || b;
          label.textContent = 'Unavailable';
        });
        return;
      }
      if (idInput) idInput.value = variant.id;

      priceEls.forEach(function (el) { el.textContent = formatMoney(variant.price); });
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEls.forEach(function (el) {
        el.style.display = hasCompare ? '' : 'none';
        if (hasCompare) {
          var target = el.querySelector('s') || el;
          target.textContent = formatMoney(variant.compare_at_price);
        }
      });
      if (saveEl) {
        saveEl.style.display = hasCompare ? '' : 'none';
        if (hasCompare) {
          saveEl.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price);
        }
      }

      buyButtons.forEach(function (b) {
        var label = b.querySelector('[data-cta-label]') || b;
        var priceSuffix = b.hasAttribute('data-show-price') ? ' · ' + formatMoney(variant.price) : '';
        if (variant.available) {
          b.disabled = false;
          label.textContent = b.getAttribute('data-label-add') + priceSuffix;
        } else {
          b.disabled = true;
          label.textContent = 'Sold out';
        }
      });

      /* Low stock note: only shown when inventory is tracked and low */
      if (stockNote) {
        var threshold = parseInt(stockNote.getAttribute('data-threshold') || '5', 10);
        var qty = variant.inventory_quantity;
        var managed = variant.inventory_management === 'shopify';
        var show = managed && typeof qty === 'number' && qty > 0 && !(qty > threshold) && variant.available;
        stockNote.style.display = show ? '' : 'none';
        var qtyEl = stockNote.querySelector('[data-stock-qty]');
        if (qtyEl && show) qtyEl.textContent = qty;
        var fillEl = stockNote.querySelector('[data-stock-fill]');
        if (fillEl && show) {
          var pctFill = Math.round((qty / threshold) * 100);
          fillEl.style.width = Math.max(8, Math.min(100, pctFill)) + '%';
        }
      }

      /* Gallery: jump to variant image */
      if (variant.featured_image && mainImage) {
        thumbs.forEach(function (t) {
          if (t.getAttribute('data-media-id') === String(variant.featured_image.id)) t.click();
        });
      }

      /* Update selected value labels per option group */
      optionGroups.forEach(function (group) {
        var label = group.querySelector('[data-selected-option]');
        var sel = group.querySelector('.option-pill.is-selected');
        if (label && sel) label.textContent = sel.getAttribute('data-value');
      });
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.option-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.option-pill').forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          updateUI(findVariant(selectedOptions()));
        });
      });
    });

    /* Add to cart (AJAX) */
    buyButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        if (button.disabled || button.classList.contains('is-added')) return;
        var variantId = idInput ? idInput.value : null;
        if (!variantId) return;

        button.disabled = true;
        /* Main variant + any checked add-ons (koper template) in one call */
        var items = [{ id: parseInt(variantId, 10), quantity: 1 }];
        root.querySelectorAll('[data-addon-checkbox]:checked').forEach(function (box) {
          items.push({ id: parseInt(box.value, 10), quantity: 1 });
        });
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
            return res.json();
          })
          .then(function () {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            setCartCount(cart.item_count);
            if (window.openCartDrawer) window.openCartDrawer(cart);
            var label = button.querySelector('[data-cta-label]') || button;
            var original = label.textContent;
            button.classList.add('is-added');
            label.textContent = '✓ In your cart';
            button.disabled = false;
            setTimeout(function () {
              button.classList.remove('is-added');
              label.textContent = original;
            }, 2000);
          })
          .catch(function (err) {
            button.disabled = false;
            var note = root.querySelector('[data-cart-error]');
            if (note) { note.textContent = err.message; note.style.display = ''; }
          });
      });
    });

    /* Initial state */
    updateUI(findVariant(selectedOptions()));
  }

  /* ---------- Cart drawer ---------- */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var itemsEl = drawer.querySelector('[data-drawer-items]');
    var subtotalEl = drawer.querySelector('[data-drawer-subtotal]');
    var countEl = drawer.querySelector('[data-drawer-count]');
    var moneyFormat = drawer.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var withComma = amount.replace('.', ',');
      var noDecimals = String(Math.round(cents / 100));
      return moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
        .replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s == null ? '' : String(s);
      return d.innerHTML;
    }

    var compareCache = {};

    function loadCompare(cart) {
      var need = [];
      cart.items.forEach(function (it) {
        if (it.handle && !compareCache[it.handle] && need.indexOf(it.handle) === -1) need.push(it.handle);
      });
      if (!need.length) return Promise.resolve(false);
      return Promise.all(need.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var m = {};
            (p.variants || []).forEach(function (v) { m[v.id] = v.compare_at_price; });
            compareCache[h] = m;
          })
          .catch(function () { compareCache[h] = {}; });
      })).then(function () { return true; });
    }

    function lineWas(item) {
      var cmp = (compareCache[item.handle] || {})[item.id];
      return cmp && cmp > item.price ? cmp * item.quantity : 0;
    }

    function render(cart) {
      draw(cart);
      loadCompare(cart).then(function (fetched) { if (fetched) draw(cart); });
    }

    function draw(cart) {
      countEl.textContent = '(' + cart.item_count + ')';
      var wasTotal = 0;
      cart.items.forEach(function (it) { wasTotal += lineWas(it) || it.final_line_price; });
      subtotalEl.innerHTML = (wasTotal > cart.total_price ? '<s class="cart-footer__was">' + formatMoney(wasTotal) + '</s>' : '') + formatMoney(cart.total_price);
      if (!cart.items.length) {
        itemsEl.innerHTML = '<div class="cart-drawer__empty">Your cart is empty.</div>';
        return;
      }
      itemsEl.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? '<img class="drawer-item__image" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_144x$1$2') + '" alt="">'
          : '<div class="drawer-item__image"></div>';
        var variant = item.product_has_only_default_variant ? '' : '<div class="drawer-item__variant">' + esc(item.variant_title || '') + '</div>';
        var price;
        var was = lineWas(item);
        var wasHtml = was ? '<s class="cart-drawer__was">' + formatMoney(was) + '</s>' : '';
        if (item.final_line_price === 0) {
          price = wasHtml + '<span class="drawer-item__free">FREE</span>';
        } else if (item.original_line_price !== item.final_line_price) {
          price = '<s class="cart-drawer__was">' + formatMoney(item.original_line_price) + '</s>' + formatMoney(item.final_line_price);
        } else {
          price = wasHtml + formatMoney(item.final_line_price);
        }
        return '<div class="drawer-item">' + img +
          '<div class="drawer-item__info">' +
            '<a class="drawer-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            variant +
            '<div class="drawer-item__price">' + price + '</div>' +
          '</div>' +
          '<div class="drawer-item__qty">' +
            '<button type="button" data-drawer-qty="-1" data-key="' + esc(item.key) + '" aria-label="Decrease">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-drawer-qty="1" data-key="' + esc(item.key) + '" aria-label="Increase">+</button>' +
          '</div>' +
        '</div>';
      }).join('');
      itemsEl.querySelectorAll('[data-drawer-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = null;
          cart.items.forEach(function (i) { if (i.key === btn.getAttribute('data-key')) item = i; });
          if (!item) return;
          var qty = Math.max(0, item.quantity + parseInt(btn.getAttribute('data-drawer-qty'), 10));
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: qty })
          })
            .then(function (res) { return res.json(); })
            .then(function (updated) {
              setCartCount(updated.item_count);
              render(updated);
            })
            .catch(function () {});
        });
      });
    }

    function open(cart) {
      if (cart) render(cart);
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    window.openCartDrawer = function (cart) {
      if (cart) { open(cart); return; }
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(open)
        .catch(function () {});
    };

    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    /* Bag link opent de drawer (behalve op de cart-pagina zelf) */
    if (!document.querySelector('[data-cart-page]')) {
      document.querySelectorAll('.cart-link').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          window.openCartDrawer();
        });
      });
    }
  }

  /* ---------- Koper PDP extras ---------- */
  function initKoper() {
    var root = document.querySelector('.product--koper');
    if (!root) return;

    /* Sticky add-to-cart bar */
    var sticky = root.querySelector('[data-sticky-atc]');
    var mainButton = root.querySelector('.product__info [data-add-to-cart]');
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', passed);
          sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(mainButton);
    }

  }

  /* ---------- Socials strips (alle templates) ---------- */
  function initSocialsStrips() {
    document.querySelectorAll('.koper-socials').forEach(function (wrap) {
      var strip = wrap.querySelector('[data-socials-strip]');
      var prev = wrap.querySelector('[data-socials-prev]');
      var next = wrap.querySelector('[data-socials-next]');
      if (!strip || !prev || !next) return;
      // Eén klik = precies één kaart verder, uitgelijnd op de kaartbreedte.
      // Eigen animatie: 'smooth' scrollBy werkt niet op overflow:hidden (mobiel is de strip alleen via de pijltjes te verschuiven)
      var cardStep = function () {
        var card = strip.firstElementChild;
        if (!card) return Math.max(180, Math.round(strip.clientWidth * 0.6));
        var gap = parseFloat(getComputedStyle(strip).columnGap) || 16;
        return card.getBoundingClientRect().width + gap;
      };
      var glideTo = function (target) {
        if (document.hidden) { strip.scrollLeft = target; return; }
        var start = strip.scrollLeft;
        var t0 = null, dur = 260;
        var tick = function (t) {
          if (t0 === null) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          strip.scrollLeft = start + (target - start) * (1 - Math.pow(1 - p, 3));
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };
      var goTo = function (dir) {
        var s = cardStep();
        var idx = Math.round(strip.scrollLeft / s) + dir;
        var max = strip.scrollWidth - strip.clientWidth;
        glideTo(Math.max(0, Math.min(idx * s, max)));
      };
      prev.addEventListener('click', function () { goTo(-1); });
      next.addEventListener('click', function () { goTo(1); });
    });
  }

  /* ---------- Video story ---------- */
  function initVideoStory() {
    document.querySelectorAll('.koper-video__frame').forEach(function (frame) {
      var video = frame.querySelector('[data-video-player]');
      var play = frame.querySelector('[data-video-play]');
      if (!video || !play) return;
      play.addEventListener('click', function () { video.play(); });
      video.addEventListener('play', function () { frame.classList.add('is-playing'); });
      video.addEventListener('pause', function () { frame.classList.remove('is-playing'); });
    });
  }

  /* ---------- Cart page quantity ---------- */
  function initCartPage() {
    var cart = document.querySelector('[data-cart-page]');
    if (!cart) return;
    cart.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.getAttribute('data-line');
        var input = cart.querySelector('input[data-line-input="' + line + '"]');
        if (!input) return;
        var qty = Math.max(0, parseInt(input.value || '0', 10) + parseInt(btn.getAttribute('data-qty-change'), 10));
        changeLine(line, qty);
      });
    });
    cart.querySelectorAll('input[data-line-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        changeLine(input.getAttribute('data-line-input'), Math.max(0, parseInt(input.value || '0', 10)));
      });
    });
    cart.querySelectorAll('[data-remove-line]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        changeLine(a.getAttribute('data-remove-line'), 0);
      });
    });
    function changeLine(line, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      }).then(function () { window.location.reload(); });
    }
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    var el = document.querySelector('[data-recommendations]');
    if (!el) return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var inner = html.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim().length) {
          el.innerHTML = inner.innerHTML;
          initLazyImages();
          initReveal();
        }
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLazyImages();
    initReveal();
    initMobileMenu();
    initSearchToggle();
    initSort();
    initCartDrawer();
    initProduct();
    initKoper();
    initSocialsStrips();
    initVideoStory();
    initCartPage();
    initRecommendations();
  });
})();
